'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: relative;\n  max-width: 400px;\n  border: solid 1px ', ';\n  border-radius: ', ';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-border-vertical-spacing: 0;\n  -webkit-border-horizontal-spacing: 0;\n'], ['\n  display: inline-block;\n  position: relative;\n  max-width: 400px;\n  border: solid 1px ', ';\n  border-radius: ', ';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-border-vertical-spacing: 0;\n  -webkit-border-horizontal-spacing: 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-height: 210px;\n'], ['\n  max-height: 210px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-top-left-radius: ', ';\n  border-top-right-radius: ', ';\n  min-height: 200px;\n  min-width: 200px;\n  max-height: 210px;\n  max-width: 400px;\n'], ['\n  border-top-left-radius: ', ';\n  border-top-right-radius: ', ';\n  min-height: 200px;\n  min-width: 200px;\n  max-height: 210px;\n  max-width: 400px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  border-top: 1px solid ', ';\n  font-size: 12px;\n  line-height: 15px;\n'], ['\n  border-top: 1px solid ', ';\n  font-size: 12px;\n  line-height: 15px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-weight: 600;\n'], ['\n  font-weight: 600;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  border-top: 1px solid ', ';\n'], ['\n  border-top: 1px solid ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 500;\n'], ['\n  color: ', ';\n  font-weight: 500;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getFirstTemplate = require('conversations-schema/operators/chat-rich-template/getFirstTemplate');

var _getFirstTemplate2 = _interopRequireDefault(_getFirstTemplate);

var _getFirstButtonText = require('conversations-schema/operators/chat-rich-template/getFirstButtonText');

var _getFirstButtonText2 = _interopRequireDefault(_getFirstButtonText);

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CHAT_BORDER_RADIUS = '25px';
var FACEBOOK_GRAY_TEXT = '#929292';
var LINK_COLOR = '#0091ae';
var PreviewContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__PreviewContainer'
})(_templateObject, _colors.BATTLESHIP, CHAT_BORDER_RADIUS);
var ImageContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__ImageContainer'
})(_templateObject2);
var Image = (0, _styledComponents2.default)(_UIImage2.default).withConfig({
  displayName: 'ChatRichTemplate__Image'
})(_templateObject3, CHAT_BORDER_RADIUS, CHAT_BORDER_RADIUS);
var TextContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__TextContainer'
})(_templateObject4, _colors.BATTLESHIP);
var Title = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__Title'
})(_templateObject5);
var Subtitle = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__Subtitle'
})(_templateObject6, FACEBOOK_GRAY_TEXT);
var Footer = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__Footer'
})(_templateObject7, _colors.BATTLESHIP);
var Button = _styledComponents2.default.div.withConfig({
  displayName: 'ChatRichTemplate__Button'
})(_templateObject8, LINK_COLOR);

var TOOLTIP_HOVER_DELAY = 1000;

var ChatRichTemplate = function (_Component) {
  _inherits(ChatRichTemplate, _Component);

  function ChatRichTemplate() {
    _classCallCheck(this, ChatRichTemplate);

    return _possibleConstructorReturn(this, (ChatRichTemplate.__proto__ || Object.getPrototypeOf(ChatRichTemplate)).apply(this, arguments));
  }

  _createClass(ChatRichTemplate, [{
    key: 'renderTooltipTimestamp',
    value: function renderTooltipTimestamp() {
      var message = this.props.message;

      var timestamp = (0, _messageTypeComparators.isInitialMessage)(message) ? (0, _commonMessageFormatGetters.getClientTs)(message) : (0, _commonMessageFormatGetters.getTimestamp)(message);

      return _I18n2.default.moment(timestamp).format('lll');
    }
  }, {
    key: 'render',
    value: function render() {
      var message = this.props.message;

      var template = (0, _getFirstTemplate2.default)(message);
      return template && _react2.default.createElement(
        _UITooltip2.default,
        {
          delay: TOOLTIP_HOVER_DELAY,
          placement: 'left',
          title: this.renderTooltipTimestamp()
        },
        _react2.default.createElement(
          'div',
          { className: 'm-top-2 justify-end m-bottom-1' },
          _react2.default.createElement(
            PreviewContainer,
            { className: 'text-center' },
            _react2.default.createElement(
              ImageContainer,
              null,
              _react2.default.createElement(Image, { responsive: false, src: template.imageUrl })
            ),
            _react2.default.createElement(
              TextContainer,
              { className: 'text-left p-y-1 p-x-2' },
              _react2.default.createElement(
                Title,
                { className: 'm-bottom-0' },
                template.title
              ),
              _react2.default.createElement(
                Subtitle,
                null,
                template.subtitle
              )
            ),
            _react2.default.createElement(
              Footer,
              { className: 'text-center p-y-4 p-x-3' },
              _react2.default.createElement(
                Button,
                null,
                (0, _getFirstButtonText2.default)(message)
              )
            )
          )
        )
      );
    }
  }]);

  return ChatRichTemplate;
}(_react.Component);

ChatRichTemplate.propTypes = {
  message: _react.PropTypes.object.isRequired
};

exports.default = ChatRichTemplate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/ChatRichTemplate.js
// module id = 541
// module chunks = 2 3